import Scrollbar from './src/scrollbar';
import { withInstall } from '../_util/type';
export default withInstall(Scrollbar);
